import styled from 'styled-components';
import { PhotographyWrapper } from '../photography/PhotographyStyles';

export const FloorPlansWrapper = styled(PhotographyWrapper)`
  .floor-hero-preview { margin: 0; background: #f6f8fc; border-radius: 16px; padding: 32px; }
  .floor-hero-preview img { display: block; width: 100%; height: 430px; object-fit: contain; }
  .floor-hero-preview figcaption { text-align: center; font: 600 16px/1.5 'Nunito Sans',sans-serif; color: #52617e; margin-top: 12px; }
  .floor-samples { background: #f6f8fc; }
  .floor-samples section { padding-top: 64px; padding-bottom: 28px; }
  .floor-samples .photo-grid { grid-template-columns: repeat(2,minmax(0,1fr)); }
  .floor-samples .image-card { background: white; }
  .floor-samples .image-card img { height: 330px; object-fit: contain; padding: 24px; }
  .floor-samples .photo-section.floor-format-grid { padding-top: 0; padding-bottom: 64px; }
  .floor-format-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 48px; }
  .floor-format-grid .photo-eyebrow { margin-bottom: 12px; }
  .floor-format-grid p:not(.photo-eyebrow), .floor-benefits p { font: 400 17px/1.7 'Nunito Sans',sans-serif; color: #52617e; margin: 0; }
  .floor-intro { display: grid; grid-template-columns: 1fr 1fr; gap: 56px; align-items: center; }
  .floor-intro .photo-title, .floor-intro .photo-copy { margin-bottom: 0; }
  .floor-benefits { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 40px; margin-top: 40px; }
  .floor-benefits .photo-step-number { font-size: 20px; margin-bottom: 14px; }
  .floor-process { padding-bottom: 24px; }
  .floor-final-visual { background: #f6f8fc; }
  .floor-final-visual img { object-fit: contain; padding: 28px; }
  @media(max-width:991px) { .floor-hero-preview { padding: 20px; } .floor-hero-preview img { height: 370px; } .floor-intro { gap: 32px; } .floor-benefits { gap: 24px; } }
  @media(max-width:767px) {
    .floor-hero-preview img { height: 240px; }
    .floor-hero-preview figcaption { font-size: 15px; }
    .floor-samples section { padding-top: 44px; }
    .floor-samples .photo-grid { grid-template-columns: 1fr; }
    .floor-samples .image-card img { height: 240px; padding: 16px; }
    .floor-samples .photo-section.floor-format-grid { padding-bottom: 44px; }
    .floor-intro, .floor-format-grid, .floor-benefits { grid-template-columns: 1fr; gap: 24px; }
    .floor-benefits { margin-top: 28px; }
    .floor-benefits article { display: grid; grid-template-columns: 36px 1fr; column-gap: 16px; }
    .floor-benefits .photo-step-number { grid-row: span 2; }
    .floor-benefits h3 { font-size: 19px; margin-bottom: 8px; }
    .floor-benefits p { grid-column: 2; font-size: 16px; }
  }
`;
